import { render, staticRenderFns } from "./createProduct.vue?vue&type=template&id=0dda3495"
import script from "./createProduct.vue?vue&type=script&lang=ts"
export * from "./createProduct.vue?vue&type=script&lang=ts"
import style0 from "./createProduct.vue?vue&type=style&index=0&id=0dda3495&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports